import React, { useRef } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { Editor } from "@tinymce/tinymce-react";

export default function CreateMail() {
    const editorRef = useRef(null);
    const log = () => {
      if (editorRef.current) {
        console.log(editorRef.current.getContent());
      }
    };
  return (
    <Layout>
      <div className="right-top">
        <div className="heading-top-inner">
          <h2>Create New Mail</h2>

          <div>
            <hr />
          </div>
        </div>
      </div>
      <Container fluid>
        <div className="product-cmn-tab">
          <Row>
            <Col lg={4}>
              <div className="product-tab-left">
                <Link to="/MailingList">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="42"
                    viewBox="0 0 40 42"
                    fill="none"
                  >
                    <path
                      d="M10 21L8.91379 22.0345L7.92857 21L8.91379 19.9655L10 21ZM30 19.5C30.8284 19.5 31.5 20.1716 31.5 21C31.5 21.8284 30.8284 22.5 30 22.5V19.5ZM15.5805 29.0345L8.91379 22.0345L11.0862 19.9655L17.7529 26.9655L15.5805 29.0345ZM8.91379 19.9655L15.5805 12.9655L17.7529 15.0345L11.0862 22.0345L8.91379 19.9655ZM10 19.5H30V22.5L10 22.5L10 19.5Z"
                      fill="#40413A"
                    />
                  </svg>{" "}
                  Back to previous page
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
      <Container fluid className="height-set px-4">
        <Row>
          <Col lg={8}>
            <div className="customer-form-new mb-4">
              <div className="customer-form-inner">
                <Row>
                  <Col lg={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Subject</Form.Label>
                      <Form.Control type="text" placeholder="Type Here" />
                    </Form.Group>
                  </Col>
                  <Col lg={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Send to</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Type Email Here"
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={12}>
                    <Form.Label>Scheduled Date & Time</Form.Label>
                    <Row>
                      <Col lg={3}>
                        <Form.Control type="date" placeholder="Type Here" />
                      </Col>
                      <Col lg={3}>
                        <Form.Control type="time" placeholder="Type Here" />
                      </Col>
                      <Col
                        lg={6}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <div className="cmn-btn ">
                          <Link to="#">SCHEDULE</Link>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="text-editor">
              <Editor
                apiKey="your-api-key"
                onInit={(evt, editor) => (editorRef.current = editor)}
                initialValue="<p>This is the initial content of the editor.</p>"
                init={{
                  height: 500,
                  menubar: false,
                  plugins: [
                    "advlist",
                    "autolink",
                    "lists",
                    "link",
                    "image",
                    "charmap",
                    "preview",
                    "anchor",
                    "searchreplace",
                    "visualblocks",
                    "code",
                    "fullscreen",
                    "insertdatetime",
                    "media",
                    "table",
                    "code",
                    "help",
                    "wordcount",
                  ],
                  toolbar:
                    "undo redo | blocks | " +
                    "bold italic forecolor | alignleft aligncenter " +
                    "alignright alignjustify | bullist numlist outdent indent | " +
                    "removeformat | help",
                  content_style:
                    "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                }}
              />
            </div> 
           
          </Col>
          <Col lg={4}>
            {" "}
            <div className="product-overview-right">
              <div className="product-overview-box">
                <h2>Publish Status</h2>
                <Form.Select aria-label="Default select example">
                  <option>DRAFT</option>
                  <option value="1">Published</option>
                </Form.Select>
                <div className="cmn-btn mt-4 d-flex justify-content-center">
                  <Link to="#">Save</Link>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={8} className="d-flex justify-content-end mt-2 mb-3">
            {" "}
            <div className="cmn-btn mt-4 mb-3">
              <Link to="#">Add BLog</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
}
